import emailjs from '@emailjs/browser';

// EmailJS configuration from the older website
const EMAIL_CONFIG = {
  serviceId: 'service_frjcs0d',
  templateId: 'template_elcslnb',
  publicKey: '0DEkykpeegiHBmXre'
};

/**
 * Send email using EmailJS
 * @param {Object} formData - The form data containing name, email, message, etc.
 * @returns {Promise} - Promise that resolves on success or rejects on error
 */
export const sendEmail = (formData) => {
  return emailjs.send(
    EMAIL_CONFIG.serviceId,
    EMAIL_CONFIG.templateId,
    formData,
    {
      publicKey: EMAIL_CONFIG.publicKey
    }
  );
};

/**
 * Initialize EmailJS (optional, can be called once in the app)
 */
export const initEmailJS = () => {
  emailjs.init(EMAIL_CONFIG.publicKey);
};
